import { Colors } from '@utex/ui-kit';
import { ViewType } from '../../types';

export const headerButtonView = {
  white: {
    static: {
      color: Colors.text.inverse,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    hover: {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
    active: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    focus: {
      boxShadowColor: 'rgba(255, 255, 255, 0.4)',
    },
  },
  'white-dim': {
    static: {
      color: Colors.text.inverse,
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    hover: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    active: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    focus: {
      boxShadowColor: 'rgba(255, 255, 255, 0.4)',
    },
  },
  black: {
    static: {
      color: Colors.text.default,
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    hover: {
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
    },
    active: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    focus: {
      boxShadowColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  'black-dim': {
    static: {
      color: Colors.text.default,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    hover: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
    active: {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    focus: {
      boxShadowColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
};

export function getExtraDimHeaderButton(view: ViewType) {
  switch (view) {
    case 'white':
      return headerButtonView['white'];

    case 'black':
      return headerButtonView['black'];

    default:
      return 'extra-dim';
  }
}

export function getPrimaryDimHeaderButton(view: ViewType) {
  switch (view) {
    case 'white':
      return headerButtonView['white-dim'];

    case 'black':
      return headerButtonView['black-dim'];

    default:
      return 'primary-dim';
  }
}

export function getTransparentButtonColor(view: ViewType) {
  switch (view) {
    case 'white':
      return headerButtonView['white'];

    case 'black':
      return headerButtonView['black'];

    default:
      return 'transparent';
  }
}
